import { Forge } from "../types";
import { EmptyForge } from "./empty-forge";

export const ForgesList = ({ forges }: { forges: Forge[] }) => {
    return (
        <div className="gap-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
            {forges.map((forge) => (
                <div key={forge.id} className="flex flex-col gap-4">
                    <h2 className="font-semibold text-lg">{forge.creator.name}</h2>
                </div>
            ))}
        </div>
    );
};